// Sandwich styles data
const styles = [
  {
    id: 1,
    name: 'Plain',
    description: 'Meat on bread, no extra fuss',
    price_adjustment: 0.00,
    double_meat: false
  },
  {
    id: 2,
    name: 'Special',
    description: 'Includes: Swiss Cheese, Coleslaw, Russian Dressing',
    price_adjustment: 3.00,
    double_meat: false
  },
  {
    id: 3,
    name: 'Super',
    description: 'Includes: Mayo, Lettuce, Tomato, and Swiss Cheese',
    price_adjustment: 3.00,
    double_meat: false
  },
  {
    id: 4,
    name: 'New Yorker',
    description: 'Double the meat for hearty appetites',
    price_adjustment: 7.00,
    double_meat: true
  }
];

export default styles;